import { createStyles, makeStyles } from '@material-ui/core/styles';
import colors from '../../../styles/Variables';

const useStyles = makeStyles((theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      fontFamily: 'Source Sans Pro',
      fontWeight: 'normal',
      fontSize: 16,
      lineHeight: '22px',
      color: colors.secondary,
      maxWidth: 432,
      width: '100%',
      boxSizing: 'border-box',
      border: '1px solid #E2E4F0',
      borderRadius: '8px',
      [theme.breakpoints.down('xs')]: {
        maxWidth: 328,
      },
    },
    content: {
      padding: '24px 24px 24px 24px',
      width: '85%',
    },
    title: {
      display: 'flex',
      marginBottom: 20,
    },
    titleInfo: {
      marginLeft: 15,
      width: '90%',
    },
    titleText: {
      margin: '0 0 8px 0',
      fontSize: 24,
      lineHeight: '30px',
      fontWeight: 'bold',
      inlineSize: '100%',
      overflowWrap: 'break-word',
    },
    titleTags: {
      fontSize: 0,
    },
    titleTag: {
      marginRight: 12,
    },
    participantsList: {
      height: 33,
    },
    weatherWrapper: {
      marginRight: 15,
    },
    weatherImg: {
      display: 'block',
      width: 75,
      margin: 'auto',
      marginTop: 0,
      marginBottom: -15,
    },
    weatherDescription: {
      textAlign: 'center',
      fontSize: 15,
      marginBottom: 5,
      marginTop: 0,
    },
    weatherWind: {
      textAlign: 'center',
      color: '#c0c0c0',
      fontSize: 15,
      display: 'flex',
      justifyContent: 'center',
      marginTop: 5,
    },
    temperatureWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 10,
    },
    weatherTemperature: {
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: 20,
      margin: 0,
      marginTop: 0,
    },
    timeTemperature: {
      display: 'flex',
      alignItems: 'center',
      gap: 5,
    },
  }),
);

export default useStyles;
